export default __webpack_public_path__ + "static/ipumc-social-logo-9b217146504bb564b1e61ced87d8a627.jpg";